<template>
  <!-- exhibition-activity .ep -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>My Cloud Booth</BreadcrumbItem>
          <BreadcrumbItem to="/exhibitionEn/index/activity/allpro">Activity Arrangement</BreadcrumbItem>
          <BreadcrumbItem>Edit activities</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="f-tar" style="margin:36px 0;">
        <Button @click="$router.push('/exhibitionEn/index/activity/allpro')">Back</Button>
      </div>
    </div>
    <div class="editpro">
      <div class="editpro-box">
        <Form ref="form" :model="form" :label-width="160" :rules="ruleValidate">
          <FormItem label="Activity name:" prop="name">
            <Input v-model="form.name" placeholder="Activity name" style="width: 400px"></Input>
          </FormItem>
          <FormItem label="Event poster:" prop="proImg">
            <div>
              <upload
                ref="upload1"
                :fileList="uploadBanner"
                :config="uploadBannerConfig"
                @upload-ok="bannerOK"
              />
            </div>
          </FormItem>
          <FormItem label="Activity video:" prop="proVideo">
            <div>
              <upload
                :config="uploadVideoConfig"
                @upload-ok="videoOK"
                :fileList="uploadVideo"
                class="upload-1"
                ref="upload2"
              />
            </div>
          </FormItem>
        <FormItem label="Activity Type：" prop="TypeName" clearable>
          <Select v-model="form.TypeName" style="width:400px" placeholder="Activity Type">
            <Option v-for="item in TypeNameArr" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem>
          <FormItem label="Time:" prop="date">
            <DatePicker
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="Please select an event time"
              style="width: 400px;"
              v-model="applyDate"
            ></DatePicker>
          </FormItem>
          <FormItem label="Type of event location:" prop="addressType">
            <RadioGroup v-model="form.addressType" @on-change="changeAddressType">
              <Radio label="线上">
                <span>Online</span>
              </Radio>
              <Radio label="线下">
                <span>offline</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="Venue:" prop="address" v-if="form.addressType === '线下'">
            <Input
              style="width: 400px"
              type="text"
              v-model="form.address"
              placeholder="Booth number, conference room, etc"
            />
          </FormItem>
          <FormItem label="Date:" prop="Timetable">
            <Input
              v-model="form.Timetable"
              type="textarea"
              :rows="4"
              placeholder="Date"
              style="width: 400px"
            ></Input>
          </FormItem>

          <FormItem label="Display order:">
            <InputNumber v-model="form.showIndex" :min="0" style="width:100px;margin-right:10px;"></InputNumber>
          </FormItem>

          <FormItem label="Activity details:" class="ivu-form-item-required">
            <div class="no-padding">
              <customComponentCommon v-model="Introduction" :type="commonType" @change="changModal"></customComponentCommon>
            </div>
          </FormItem>
        </Form>
        <div style="width:100%;padding-left:160px;">
          <Button
            type="primary"
            @click="handleSubmit('form',0)"
            style="width:140px;height:35px;font-size:14px"
          >Save</Button>
          <Button
            type="primary"
            @click="handleSubmit('form',1)"
            style="width:140px;height:35px;font-size:14px;margin-left:20px;"
          >Save and Preview</Button>
        </div>
      </div>
    </div>
    <Contact />
  </div>
</template>

<script>
let moment = require("moment");
import Contact from "@components/En/Contact/Contact";
import upload from "@components/En/upLoad/upLoad";
import { mapGetters, mapActions } from "vuex";
import customComponentCommon from "@components/En/custom-component/custom-component-common.vue";

export default {
  name: "exhibition-activity-edit",
  data() {
    let that = this;
    const validateProImg = (rule, value, callback) => {
      if (that.uploadBanner && that.uploadBanner.length) {
        callback();
      } else {
        // that.$Message.warning("请上传活动图片");
        callback(new Error("Please upload the event poster"));
      }
    };
    const proApply = (rule, value, callback) => {
      if (that.applyDate[1]) {
        callback();
      } else {
        callback(new Error("Please select an event time"));
      }
    };
    return {
      commonType: 2, //
      list: null,
      pageSize: 16,
      pageIndex: 1,
      totalCount: 0,

      editData: "",
      Introduction: [], // 活动详情

      uploadBanner: [], // 活动图
      uploadVideo: [], // 主图视频
      applyDate: [], // 体验报名时间
      config: {
        fileType: "img",
        headers: {},
        action: "",
        format: ["jpg", "jpeg", "png"],
        "max-size": 2048,
        remind:
          "(Poster requirement: .jpg/.png within 2M, suggested size is 900*600px. No more than 15 files)",
        limitNum: 15
      },
      form: {
        name: "", // 活动名称
        address: "", // 活动流程
        addressType: "线下", // 活动地点
        Timetable: "", // 活动流程
        showIndex: 0, // 显示顺序
        isShow: true, // 是否显示
        TypeName: '', // 显示顺序
      },
      ruleValidate: {
        name: [
          { required: true, message: "Activity name cannot be empty", trigger: "blur" }
        ],
        address: [
          { required: true, message: "The venue cannot be empty", trigger: "blur" }
        ],
        proImg: [
          { required: true, validator: validateProImg, trigger: "change" }
        ],
        TypeName: [
          { required: true, message: "Activity type is required", trigger: "blur" }
        ],
        date: [{ required: true, validator: proApply, trigger: "blur" }]
      },
      videoList: [], // 视频详情
      type: [],
      type2: [],
      TypeNameArr: ["New product release", "Signing ceremony", "Sales promotion", "Complimentary samples", "Others"]
    };
  },
  computed: {
    uploadBannerConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_1";
      config.headers = this.formHeaders;
      config.action = this.uploadUrl;
      return config;
    },
    uploadVideoConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_2";
      config.fileType = "video";
      config.headers = this.formHeaders;
      config.action = this.uploadVideoUrl;
      config.format = ["mp4"];
      config["max-size"] = 51200; // 50M
      config.limitNum = 1;
      config.remind =
        "(Requirements: within 50M, suggested length is 9-30s, image scale is 16:9)";
      return config;
    },
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo"
    }),
    query() {
      return this.$router.history.current.query;
    },
    option() {
      return { compId: this.company.id, pageSize: 1000 };
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getActivityById: "activityModuleNew/getActivityById",
      editActivity: "activityModuleNew/editActivity",

      transformCustomData: "customComponentModule/transformCustomData",
      transformReqCustomData: "customComponentModule/transformReqCustomData"
    }),
    async init() {
      if (!this.query.id) return;
      this.editData = await this.getActivityById(this.query.id);
      this.form.name = this.editData.name;
      if (JSON.parse(this.editData.banner)) {
        this.uploadBanner = JSON.parse(this.editData.banner);
      }
      if (JSON.parse(this.editData.video).Link) {
        this.uploadVideo = [
          {
            url: JSON.parse(this.editData.video).Link,
            src: JSON.parse(this.editData.video).Img
          }
        ];
      }
      this.form.TypeName = this.editData.typeName;  
      this.form.address = this.editData.address;
      if (this.form.address === "线上") {
        this.form.addressType = "线上";
      } else {
        this.form.addressType = "线下";
      }
      this.form.Timetable = this.editData.timetable;
      this.form.showIndex = this.editData.showIndex;
      if (this.editData.startTime && this.editData.endTime) {
        this.applyDate = [this.editData.startTime, this.editData.endTime];
      }
      if (
        this.editData.introduction &&
        this.editData.introduction.indexOf("[") !== -1
      ) {
        this.Introduction = await this.transformCustomData(
          JSON.parse(this.editData.introduction)
        );
      }
    },
    bannerOK(list) {
      this.uploadBanner = list;
    },
    videoOK(list) {
      this.uploadVideo = list;
    },
    changeApply() {
      if (this.form.apply === false) {
        this.applyDate = [];
        this.form.applyMaxCount = 0;
      }
    },
    changePrice() {
      if (this.form.showPrice === false) {
        this.form.price = 0;
        this.form.linePrice = 0;
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async handleSubmit(name,e) {
      let txt = "";
      let valid = await this.validForm(name);
      this.$refs[name].fields.forEach(c => {
        if (txt) return;
        if (c.validateState === "error") {
          txt = c.validateMessage;
        }
      });
      if (!valid && txt) {
        this.$Message.warning(txt);
      }
      if (!valid) return;
      // 主图视频
      let video = {
        cover: 0,
        Time: 200,
        Img: "",
        Link: ""
      };
      if (this.uploadVideo.length > 0) {
        video.Link = this.uploadVideo[0].url;
        video.Img = this.uploadVideo[0].src;
      }
      // 活动详情
      let Introduction = await this.transformReqCustomData(this.Introduction);
      if (!Introduction || Introduction === "[]") {
        this.$Message.error("Please complete the details");
        return;
      }

      let start = moment(this.applyDate[0]).format("YYYY-MM-DD HH:mm:ss");
      let end = moment(this.applyDate[1]).format("YYYY-MM-DD HH:mm:ss");

      let form = {
        Id: this.editData.id,
        SetValues: {
          Name: this.form.name,
          Banner: this.uploadBanner,
          Video: video,
          StartTime: start,
          EndTime: end,
          Timetable: this.form.Timetable,
          Address: this.form.address,
          ShowIndex: this.form.showIndex,
          Introduction: Introduction,
          TypeName: this.form.TypeName,
        }
      };
      let bool = await this.editActivity(form);
      if (bool.successed) {
        this.$Message.success("successful");
        if (e === 0) {
          this.$router.push("/exhibitionEn/index/activity/allpro");
        }
        if (e === 1) {
          this.$router.push("/exhibitionEn/index/template");
        }
      } else {
        this.$Message.error("fail,please try again");
      }
    },

    changModal($event) {
      this.Introduction = $event;
    },
    changeAddressType(e) {
      if(e === '线上') {
        this.form.address = '线上';
      } else {
        this.form.address = '';
      }
    }
  },
  components: {
    Contact,
    upload,
    customComponentCommon
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss">
.editpro {
  .ivu-modal-header {
    border-bottom: none;
    padding: 14px 0;
  }
}
</style>
<style scoped lang="scss">
.ecb {
  .editpro {
    background-color: #fff;
    margin: 30px;
    min-width: 800px;
    &-box {
      padding: 20px 85px 40px 50px;
    }
  }
  .text-box {
    width: 375px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border: dashed 1px rgba(191, 191, 191, 0.5);
    border-radius: 5px;
    cursor: pointer;
    &:hover {
      border: dashed 1px rgba(23, 143, 255, 1);
    }
  }

  .c-1 {
    &:hover {
      background-color: #f2f2f2;
    }
  }
  .c-2 {
    &:hover {
      background-color: #f2f2f2;
    }
  }
  .c-3 {
    &:hover {
      background-color: #f2f2f2;
    }
  }
}
.v-center {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 500;
  }
}
</style>
